import { RadarChart } from "@components/Spider/RadarChart";
import styles from "./styles.module.scss";
import React from "react";
import { SpiderChartProps } from "./types";

export const SpiderChart = React.memo(
  ({
    AspectsStats,
    activeIndex,
    setActiveIndex,
    whatIfCompare,
    matchedOriginalAspects = [],
    compareAspectsData = [],
  }: SpiderChartProps) => {
    const aspectsToUse =
      matchedOriginalAspects && matchedOriginalAspects.length > 0
        ? matchedOriginalAspects
        : AspectsStats;
    const hasEnoughAspects = aspectsToUse.length >= 3;

    const radarData = aspectsToUse.map((aspect) => ({
      label: aspect.aspect,
      value: (aspect.bayesian_avg !== undefined
        ? aspect.bayesian_avg
        : aspect.avg
      ).toFixed(1),
    }));

    let compareData = [];
    if (compareAspectsData && compareAspectsData.length > 0) {
      compareData = compareAspectsData.map((aspect) => aspect.avg.toFixed(1));
    }

    const handleDotClick = (index: number) => {
      setActiveIndex(index);
    };

    if (!hasEnoughAspects) {
      return (
        <div className={styles.wrapper}>
          <div className={styles.notEnoughAspects}>
            <p>Not enough aspects to compare (minimum 3 required)</p>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.wrapper}>
        <RadarChart
          datasets={[
            {
              label: "Current Aspect",
              data: radarData.map((item) => item.value),
              borderColor: "#5295E0",
              borderDash: whatIfCompare ? [6, 4] : undefined,
            },
            ...(compareData.length
              ? [
                  {
                    label: "Compare Aspect",
                    data: compareData,
                    borderColor: whatIfCompare
                      ? "rgba(0, 238, 255, 0.60)"
                      : "#0EF",
                  },
                ]
              : []),
          ]}
          padding={0}
          activeIndex={activeIndex}
          onDotClick={handleDotClick}
          isDragEnabled={whatIfCompare}
          showTooltipWithArrow={false}
          blockChanging={false}
          width={530}
          height={440}
          top={-80}
          left={"50%"}
          labelFontSize={11}
          suggestedMax={10}
          productOneTitles={radarData.map((item) => item.label)}
          productOneValues={radarData.map((item) => parseFloat(item.value))}
          productTwoValues={compareData.map((v) => parseFloat(v))}
        />
      </div>
    );
  },
);
